import React from "react";
import PropTypes from "prop-types";
import { MathJax } from "better-react-mathjax";
import { RichText } from "@learningblocks/shared-components/lib/RichText";

export const Equation = ({ text }) => {
   /**
   * Check if text contains MathJax expressions
   * @param {string} text - Text to check
   * @returns {boolean} True if text contains MathJax expressions
   */
   const containsMathJax = (text) => {
    if (!text || typeof text !== 'string') return false;
    // Check for MathJax patterns: $$...$$ or $...$
    return /\$\$.*?\$\$|\$.*?\$/g.test(text);
  };

  const renderMixedContent = (text) => {
    if (!text || typeof text !== "string") return text;
  
    // Skip if there's no math
    if (!containsMathJax(text)) {
      return <RichText text={text} />
    }
  
    // Split text by MathJax expressions while preserving delimiters
    const parts = text.split(/(\$\$.*?\$\$|\$.*?\$)/g).filter(Boolean);
  
    return (
      <>
        {parts.map((part, index) => {
          if (containsMathJax(part)) {
            // Detect whether it's inline ($...$) or display ($$...$$)
            const isInline = /^\$(?!\$)(.*?)(?<!\$)\$$/.test(part);
            return (
              <MathJax key={index} inline={isInline} dynamic>
                {part}
              </MathJax>
            )
          }
          return <RichText text={part} />;
        })}
      </>
    );
  };

  return (
    renderMixedContent(text)
  );
};

Equation.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  text: PropTypes.string.isRequired,
};
